import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const HomeView = () => import('../views/home/index.vue')
const ProductsView = () => import('../views/products/index.vue')
const CommunityView = () => import('../views/community/index.vue')
const PartnershipView = () => import('../views/partnership/index.vue')
const PartnershipPainPointsView = () => import('../views/partnership-pain-points/index.vue')
const AboutView = () => import('../views/about/index.vue')
const MenuView = () => import('../views/menu/index.vue')
const IndustryView = () => import('../views/industry/index.vue')
const EducationView = () => import('../views/education/index.vue')
const AcademicServicesView = () => import('../views/academic-services/index.vue')

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'home', component: HomeView },
  { path: '/products', name: 'products', component: ProductsView },
  { path: '/community', name: 'community', component: CommunityView },
  { path: '/partnership', name: 'partnership', component: PartnershipView },
  {
    path: '/partnership-pain-points',
    name: 'partnership-pain-points',
    component: PartnershipPainPointsView
  },
  { path: '/about', name: 'about', component: AboutView },
  { path: '/menu', name: 'menu', component: MenuView },
  { path: '/industry', name: 'industry', component: IndustryView },
  { path: '/education', name: 'education', component: EducationView },
  {
    path: '/academic-services',
    name: 'academic-services',
    component: AcademicServicesView
  },
  { path: '/lanhu_1shouyeyidongduan', redirect: '/home' },
  { path: '/lanhu_2chanpintixiyidongduan', redirect: '/products' },
  { path: '/lanhu_3juxingshequyidongduan', redirect: '/community' },
  { path: '/lanhu_4hezuofunengyidongduan', redirect: '/partnership' },
  {
    path: '/lanhu_hezuofunengjiaohuchangjingyidongduan',
    redirect: '/partnership-pain-points'
  },
  { path: '/lanhu_5guanyuwomenyidongduan', redirect: '/about' },
  { path: '/lanhu_7caidanyidongduan', redirect: '/menu' },
  { path: '/lanhu_guanyuwomenzhigugongye', redirect: '/industry' },
  { path: '/lanhu_guanyuwomenzhigujiaoyu', redirect: '/education' },
  { path: '/lanhu_guanyuwomenzhiguyouxue', redirect: '/academic-services' },
  { path: '*', redirect: '/home' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
